/* Teams page order builder (oc-team-builder). Quantities are kept per style, colour and size;
   Add to bag adds every line in one go, each tagged with the made-to-order lead time. */
(function () {
  'use strict';

  var moneyTpl = null;
  function money(c) {
    if (moneyTpl == null) {
      var d = document.createElement('textarea');
      d.innerHTML = window.ocMoneyFormat || '£0.00';
      moneyTpl = d.value;
    }
    var m = moneyTpl.match(/0(?:([.,])0+)?/);
    if (!m) return moneyTpl;
    var dec = m[1] || '';
    var n = (Number(c) || 0) / 100;
    var p = (dec ? n.toFixed(2) : String(Math.round(n))).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, dec === ',' ? '.' : ',');
    return moneyTpl.replace(m[0], p[0] + (dec ? dec + p[1] : ''));
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function pct(n) { return (Math.round(n * 10) / 10) + '%'; }
  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initTeam(root) {
    if (root.dataset.tmReady) return;
    var j = root.querySelector('[data-tm-json]');
    if (!j) return;
    var data;
    try { data = JSON.parse(j.textContent); } catch (e) { return; }
    root.dataset.tmReady = '1';
    var $ = function (s) { return root.querySelector(s); };
    var styles = data.styles || [];
    var sizes = data.sizes || [];
    var tiers = (data.tiers || []).filter(function (t) { return t.min > 0; }).sort(function (a, b) { return a.min - b.min; });
    var qty = {};          // "styleIndex|colour|size" -> quantity
    var g = 'women';
    var cur = {};          // gender -> { s: styleIndex, c: colour }
    var img = 0;

    function stylesFor(gender) {
      return styles.map(function (s, i) { return i; }).filter(function (i) { return styles[i].g === gender && styles[i].colours.length; });
    }
    // colours that can be ordered: with a team product, only those it has variants for
    function coloursOf(si) {
      var s = styles[si];
      if (!s.team) return s.colours;
      return s.colours.filter(function (c) { return sizes.some(function (z) { return s.v[c.n + '|' + z]; }); });
    }
    function pick() {
      if (!cur[g]) {
        var list = stylesFor(g);
        if (!list.length) return null;
        cur[g] = { s: list[0], c: (coloursOf(list[0])[0] || styles[list[0]].colours[0]).n };
      }
      return cur[g];
    }
    function colourObj(si, name) {
      var cs = styles[si].colours;
      for (var i = 0; i < cs.length; i++) if (cs[i].n === name) return cs[i];
      return cs[0];
    }
    function unit(si, c, z) {
      var v = styles[si].v[c + '|' + z];
      if (v) return { p: v.p, c: v.c };
      var co = colourObj(si, c);
      return { p: co.price, c: co.compare };
    }

    function drawGal(c) {
      var imgs = c.imgs.length ? c.imgs : [];
      var trk = $('[data-tm-track]');
      trk.innerHTML = imgs.map(function (u, i) {
        return '<img src="' + esc(u) + '" alt="' + esc(styles[pick().s].name + ' in ' + c.n + ', image ' + (i + 1)) + '"' + (i ? ' loading="lazy"' : '') + ' width="1000" height="1333">';
      }).join('');
      trk.scrollLeft = 0;
      img = 0;
      var many = imgs.length > 1;
      $('[data-tm-prev]').hidden = !many;
      $('[data-tm-next]').hidden = !many;
      $('[data-tm-cnt]').hidden = !many;
      $('[data-tm-dots]').innerHTML = many ? imgs.map(function (u, i) {
        return '<button type="button" data-tm-dot="' + i + '" aria-label="Image ' + (i + 1) + '"></button>';
      }).join('') : '';
      markImg();
    }
    function markImg() {
      var n = $('[data-tm-track]').children.length;
      $('[data-tm-cnt]').textContent = (img + 1) + ' / ' + n;
      root.querySelectorAll('[data-tm-dot]').forEach(function (d, i) { d.classList.toggle('is-on', i === img); });
    }
    function goImg(i) {
      var trk = $('[data-tm-track]');
      var n = trk.children.length;
      if (!n) return;
      img = (i + n) % n;
      trk.scrollTo({ left: img * trk.clientWidth, behavior: 'smooth' });
      markImg();
    }

    function draw() {
      var p = pick();
      root.querySelectorAll('[data-tm-g]').forEach(function (b) {
        var on = b.dataset.tmG === g;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on);
      });
      var lbl = $('[data-tm-sg-label]');
      if (lbl) lbl.textContent = (g === 'men' ? "Men's" : "Women's") + ' size guide';
      root.querySelectorAll('[data-tm-sg-for]').forEach(function (el) { el.hidden = el.dataset.tmSgFor !== g; });
      if (!p) return;
      var s = styles[p.s];
      // style chips, with a count when that style has quantities
      $('[data-tm-styles]').innerHTML = stylesFor(g).map(function (i) {
        var n = 0;
        Object.keys(qty).forEach(function (k) { if (k.split('|')[0] == i) n += qty[k]; });
        return '<button type="button" class="tm-chip' + (i === p.s ? ' is-on' : '') + '" data-tm-s="' + i + '">' + esc(styles[i].label) + (n ? '<i>' + n + '</i>' : '') + '</button>';
      }).join('');
      var cs = coloursOf(p.s);
      if (!cs.some(function (c) { return c.n === p.c; })) p.c = (cs[0] || s.colours[0]).n;
      var c = colourObj(p.s, p.c);
      $('[data-tm-name]').textContent = s.name;
      var u = unit(p.s, p.c, sizes[0]);
      $('[data-tm-price]').innerHTML = money(u.p) + (u.c > u.p ? '<s>' + money(u.c) + '</s>' : '');
      $('[data-tm-colour]').textContent = p.c;
      $('[data-tm-sw]').innerHTML = cs.map(function (co) {
        return '<button type="button" data-tm-c="' + esc(co.n) + '" class="' + (co.n === p.c ? 'is-on' : '') + '" style="background:' + esc(co.hex) + '" aria-label="' + esc(co.n) + '" aria-pressed="' + (co.n === p.c) + '" title="' + esc(co.n) + '"></button>';
      }).join('');
      var here = 0;
      $('[data-tm-sizes]').innerHTML = sizes.map(function (z) {
        var k = p.s + '|' + p.c + '|' + z;
        var q = qty[k] || 0;
        here += q;
        var ok = !s.team || !!s.v[p.c + '|' + z];
        return '<div class="tm-sz' + (q ? ' has' : '') + '"><b>' + esc(z) + '</b><span class="tm-st">' +
          '<button type="button" data-tm-dec="' + esc(z) + '" aria-label="One fewer ' + esc(z) + '"' + (ok ? '' : ' disabled') + '>−</button>' +
          '<input type="number" inputmode="numeric" min="0" step="1" value="' + q + '" data-tm-q="' + esc(z) + '" aria-label="Quantity in ' + esc(z) + '"' + (ok ? '' : ' disabled') + '>' +
          '<button type="button" data-tm-inc="' + esc(z) + '" aria-label="One more ' + esc(z) + '"' + (ok ? '' : ' disabled') + '>+</button></span></div>';
      }).join('');
      $('[data-tm-here]').textContent = here ? here + ' in ' + p.c : '';
      if (root._tmGal !== p.s + '|' + p.c) { root._tmGal = p.s + '|' + p.c; drawGal(c); }
      summary();
    }

    function lines() {
      var out = {};
      Object.keys(qty).forEach(function (k) {
        if (!qty[k]) return;
        var a = k.split('|');
        var key = a[0] + '|' + a[1];
        if (!out[key]) out[key] = { s: Number(a[0]), c: a[1], n: 0, sub: 0 };
        out[key].n += qty[k];
        out[key].sub += qty[k] * unit(Number(a[0]), a[1], a[2]).p;
      });
      return Object.keys(out).map(function (k) { return out[k]; });
    }
    function summary() {
      var ls = lines();
      var total = 0, sub = 0;
      ls.forEach(function (l) { total += l.n; sub += l.sub; });
      $('[data-tm-lines]').innerHTML = ls.length ? ls.map(function (l) {
        var s = styles[l.s];
        var short = s.name.replace(/ Scrub /, ' ');
        return '<div class="tm-ol"><span>' + esc(short) + ' · ' + esc(l.c) + '</span><span><b>' + l.n + '</b><button type="button" data-tm-rm="' + l.s + '|' + esc(l.c) + '" aria-label="Remove ' + esc(short + ' in ' + l.c) + '">×</button></span></div>';
      }).join('') : '<div class="tm-empty">Add quantities above to start your order.</div>';
      var t = null, next = tiers[0] || null;
      tiers.forEach(function (x, i) { if (total >= x.min) { t = x; next = tiers[i + 1] || null; } });
      var after = t ? Math.round(sub * (100 - t.pct) / 100) : sub;
      $('[data-tm-total]').innerHTML = '<b>' + total + ' item' + (total === 1 ? '' : 's') + '</b>' + (total ? ' · ' + (t ? '<s>' + money(sub) + '</s> ' + money(after) : money(sub)) : '');
      $('[data-tm-ok]').textContent = t ? pct(t.pct) + ' off unlocked' : '';
      // the bar runs through evenly spaced marks: 0, tier 1, tier 2, tier 3
      var marks = [0].concat(tiers.map(function (x) { return x.min; }));
      var w = 100;
      for (var i = 1; i < marks.length; i++) {
        if (total < marks[i]) { w = ((i - 1) + (total - marks[i - 1]) / (marks[i] - marks[i - 1])) * 100 / (marks.length - 1); break; }
      }
      $('[data-tm-prog]').style.width = w + '%';
      root.querySelectorAll('[data-tm-tick]').forEach(function (el) {
        el.classList.toggle('is-on', total >= (marks[Number(el.dataset.tmTick)] || 0) && total > 0);
      });
      var msg;
      if (next) {
        var left = next.min - total;
        msg = 'Add <b>' + left + ' more</b> to ' + (t ? 'reach ' : 'unlock ') + pct(next.pct) + ' off.' + (t ? ' Your discount comes off at checkout.' : '');
      } else {
        msg = 'You\'ve unlocked our best team price. Your discount comes off at checkout.';
      }
      $('[data-tm-next-msg]').innerHTML = msg;
      var btn = $('[data-tm-add]');
      var missing = ls.some(function (l) { return !styles[l.s].team; });
      btn.disabled = !total || missing;
      btn.innerHTML = (total ? 'Add ' + total + ' to bag' : 'Add to bag') + ' <span aria-hidden="true">→</span>';
      if (missing && total) $('[data-tm-msg]').textContent = 'Team ordering for this style isn\'t set up yet.';
      else if ($('[data-tm-msg]').dataset.keep !== '1') $('[data-tm-msg]').textContent = '';
    }

    function setQty(z, q) {
      var p = pick();
      q = Math.max(0, Math.min(9999, Math.floor(Number(q) || 0)));
      var k = p.s + '|' + p.c + '|' + z;
      if (q) qty[k] = q; else delete qty[k];
    }

    root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-tm-g]'))) { g = b.dataset.tmG; draw(); return; }
      if ((b = e.target.closest('[data-tm-s]'))) {
        var p = pick();
        p.s = Number(b.dataset.tmS);
        draw();
        return;
      }
      if ((b = e.target.closest('[data-tm-c]'))) { pick().c = b.dataset.tmC; draw(); return; }
      if ((b = e.target.closest('[data-tm-inc]'))) { var z = b.dataset.tmInc; setQty(z, (qty[pick().s + '|' + pick().c + '|' + z] || 0) + 1); draw(); return; }
      if ((b = e.target.closest('[data-tm-dec]'))) { var z2 = b.dataset.tmDec; setQty(z2, (qty[pick().s + '|' + pick().c + '|' + z2] || 0) - 1); draw(); return; }
      if ((b = e.target.closest('[data-tm-rm]'))) {
        var pre = b.dataset.tmRm + '|';
        Object.keys(qty).forEach(function (k) { if (k.indexOf(pre) === 0) delete qty[k]; });
        draw();
        return;
      }
      if (e.target.closest('[data-tm-prev]')) { goImg(img - 1); return; }
      if (e.target.closest('[data-tm-next]')) { goImg(img + 1); return; }
      if ((b = e.target.closest('[data-tm-dot]'))) { goImg(Number(b.dataset.tmDot)); return; }
      if ((b = e.target.closest('[data-tm-add]')) && !b.disabled) add(b);
    });
    root.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-tm-q]');
      if (!inp) return;
      setQty(inp.dataset.tmQ, inp.value);
      draw();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('[data-tm-q]')) { e.preventDefault(); e.target.blur(); }
    });
    var trk = $('[data-tm-track]');
    var st;
    trk.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var i = Math.round(trk.scrollLeft / Math.max(1, trk.clientWidth));
        if (i !== img) { img = i; markImg(); }
      }, 80);
    }, { passive: true });

    function add(btn) {
      var items = [];
      Object.keys(qty).forEach(function (k) {
        var a = k.split('|');
        var v = styles[Number(a[0])].v[a[1] + '|' + a[2]];
        if (v && qty[k]) {
          var it = { id: v.id, quantity: qty[k] };
          if (data.property && data.lead) { it.properties = {}; it.properties[data.property] = data.lead; }
          items.push(it);
        }
      });
      if (!items.length) return;
      var msg = $('[data-tm-msg]');
      var drawer = document.querySelector('cart-drawer');
      var notification = document.querySelector('cart-notification');
      var target = drawer || notification;
      var body = { items: items };
      if (target && typeof target.getSectionsToRender === 'function') {
        body.sections = target.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok) {
            msg.dataset.keep = '1';
            msg.textContent = (res.json && (res.json.description || res.json.message)) || 'Something went wrong. Please try again.';
            setTimeout(function () { msg.dataset.keep = ''; }, 4000);
            summary();
            return;
          }
          qty = {};
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            draw();
            var item = res.json.items ? res.json.items[0] : res.json;
            if (target && typeof target.renderContents === 'function' && res.json.sections) {
              item.sections = res.json.sections;
              if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
              target.renderContents(item);
            } else {
              window.location.href = cartRoot() + 'cart';
            }
          }, 600);
        })
        .catch(function () { window.location.href = cartRoot() + 'cart'; });
    }

    draw();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-oc-team]').forEach(initTeam);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
